import React, { useState, useEffect, useRef } from 'react'

const useDebounce = (callback: Function, delay: number) => {
    const callbackRef = useRef(callback)
    const timeoutRef: any = useRef()

    useEffect(() => {
        callbackRef.current = callback
    }, [callback])

    const debounce = (...args: any[]) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }
        timeoutRef.current = setTimeout(() => {
            callbackRef.current(...args)
        }, delay)
    }

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [delay])

    return debounce
}

export default useDebounce
